// extracted by mini-css-extract-plugin
export default {"container":"container__puPCS","title":"title__2IMvd","subtitle":"subtitle__PHG3y","actions":"actions__TDG18","img-link":"img-link__UMiPT"};